import React, { Fragment, useEffect, useState } from "react";
import { Button, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import JobTable from "../Dashboard/JobTable";
import { getApiUserRoles, getLiveJobList } from "../../Utils/actions";
import { useDispatch } from "react-redux";

const LIST_OF_USERS = [
  "SuperAdmin",
  "Jay",
  "Ankit",
  "Satish",
  "Gautam",
  "Yash",
  "RigAdmin",
];

const JobList = () => {
  const [logs, setLogs] = useState();
  const [well, setWell] = useState();
  const [rigsId, setRigsId] = useState();
  const [allJobsData, setAllJobsData] = useState();
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [finishJobPagination, setFinishJobPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const user = localStorage.getItem("username");
  const dispatch = useDispatch();

  useEffect(() => {
    if (sessionStorage.getItem("activeTab") != null) {
      sessionStorage.getItem("activeTab") == 0
        ? dispatch(
            getLiveJobList("active", {
              pageSize: pagination.pageSize,
              pageNumber: pagination.pageIndex + 1,
            })
          )
        : dispatch(
            getLiveJobList("finish", {
              pageSize: finishJobPagination.pageSize,
              pageNumber: finishJobPagination.pageIndex + 1,
            })
          );
    }
  }, [pagination]);

  useEffect(() => {
    dispatch(getApiUserRoles(sessionStorage.getItem("username")));
  }, []);
  return (
    <Fragment>
      <Card
        className="shadow-none jobs-full-page"
        style={{
          backgroundColor: "#333333",
          padding: "15px",
          overflow: "auto",
          height: "89vh",
          border: "none",
        }}
      >
        {/* <Card.Header>
                    <strong>Job List</strong>
                    <span className={"float-right"}>
                        
                        <Link to={"/dashboard"}>
                            <Button size={"sm"} style={{backgroundColor:'#286685', color: '#fff', border: '#286685'}} >To Dashboard</Button>
                        </Link>
                        {"  "}
                        {LIST_OF_USERS.includes(user) ? (
                            <Link to={"/configForm"}>
                                <Button size={"sm"} style={{backgroundColor:'#286685', color: '#fff', border: '#286685'}} >To Config Form</Button>
                            </Link>
                        ) : (
                            <Fragment />
                        )}
                    </span>
                </Card.Header> */}
        <Card.Body style={{ background: "#242424", borderRadius: "0.25rem" }}>
          <JobTable
            setLogs={setLogs}
            setWell={setWell}
            setRigsId={setRigsId}
            setAllJobsData={setAllJobsData}
            pagination={pagination}
            setPagination={setPagination}
            finishJobPagination={finishJobPagination}
            setFinishJobPagination={setFinishJobPagination}
          />
        </Card.Body>
      </Card>
    </Fragment>
  );
};

export default JobList;
